/**
 * @module ui.actions
 */
import { createAction } from '@reduxjs/toolkit';
import type { RootState } from '../store';

const changeAccountUI = createAction<RootState>('ui/changeAccountUI');
const changeActionPlanningUI = createAction<RootState>('ui/changeActionPlanningUI');
const changeAdminUI = createAction<RootState>('ui/changeAdminUI');
const changeAnalyzeUI = createAction<RootState>('ui/changeAnalyzeUI');
const changeConversationsUI = createAction<RootState>('ui/changeConversationsUI');
const changeEmployeesUI = createAction<RootState>('ui/changeEmployeesUI');
const changeHeatmapUI = createAction<RootState>('ui/changeHeatmapUI');
const changeLearningContentUI = createAction<RootState>('ui/changeLearningContentUI');
const changeReportingUI = createAction<RootState>('ui/changeReportingUI');
const changeResponseRateUI = createAction<RootState>('ui/changeResponseRateUI');
const changeRolesUI = createAction<RootState>('ui/changeRolesUI');
const changeSettingsUI = createAction<RootState>('ui/changeSettingsUI');
const changeSurveysUI = createAction<RootState>('ui/changeSurveysUI');
const changeSurveyTypesUI = createAction<RootState>('ui/changeSurveyTypesUI');
const changeUsersUI = createAction<RootState>('ui/changeUsersUI');
const changeSurveyBuildUI = createAction<RootState>('ui/changeSurveyBuildUI');

export const uiActions = {
  changeAccountUI,
  changeActionPlanningUI,
  changeAdminUI,
  changeAnalyzeUI,
  changeConversationsUI,
  changeEmployeesUI,
  changeHeatmapUI,
  changeLearningContentUI,
  changeReportingUI,
  changeResponseRateUI,
  changeRolesUI,
  changeSettingsUI,
  changeSurveysUI,
  changeSurveyTypesUI,
  changeUsersUI,
  changeSurveyBuildUI,
};
